import kebabCase from 'lodash/kebabCase';
import uniqueId from 'lodash/uniqueId';

import { type AutocompleteRenderInputParams } from '../..';
import {
  FormControlWrapper,
  type FormControlWrapperProps,
} from '../../../form-control-wrapper';
import {
  OutlinedInput,
  type OutlinedInputProps,
} from '../../../outlined-input';

export type AutocompleteInputSlotProps = {
  formControlWrapper?: Omit<
    FormControlWrapperProps,
    'label' | 'inputId' | 'helperText'
  >;
  outlinedInput?: Omit<OutlinedInputProps, 'placeholder'>;
};

type AutocompleteInputProps = {
  hideLabel?: boolean;
  helperText?: string;
  label: string;
  params: AutocompleteRenderInputParams;
  placeholder?: string;
  slotProps?: AutocompleteInputSlotProps;
};

export const AutocompleteInput = ({
  hideLabel,
  helperText,
  label,
  params,
  placeholder,
  slotProps,
}: AutocompleteInputProps) => {
  // TODO: MUI use useId from @mui/utils internally
  const inputId = uniqueId(kebabCase(label));

  return (
    <FormControlWrapper
      inputId={inputId}
      helperText={helperText}
      label={!hideLabel ? label : undefined}
      sx={{ width: '100%' }}
      {...slotProps?.formControlWrapper}
    >
      <OutlinedInput
        {...params.InputProps}
        {...slotProps?.outlinedInput}
        placeholder={placeholder}
        inputProps={{
          ...params.inputProps,
          ...slotProps?.outlinedInput?.inputProps,
          id: inputId,
          'aria-label': hideLabel ? label : undefined,
          'aria-labelledby': !hideLabel ? `${inputId}-label` : undefined,
          'aria-describedby': helperText ? `${inputId}-helper-text` : undefined,
        }}
      />
    </FormControlWrapper>
  );
};
